import type { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    aria-label="youtube"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="#000"
    {...props}
  >
    <path d="M19.227 3.183H4.773C2.14 3.183 0 5.331 0 7.97v8.058c0 2.64 2.14 4.787 4.773 4.787h14.454c2.632 0 4.773-2.148 4.773-4.787V7.97c0-2.64-2.14-4.787-4.773-4.787ZM23.02 16.03c0 2.1-1.701 3.807-3.793 3.807H4.773C2.68 19.836.98 18.128.98 16.03V7.97c0-2.099 1.701-3.807 3.793-3.807h14.454c2.092 0 3.793 1.708 3.793 3.807v8.059Z" />
    <path d="M16.336 11.822 9.55 7.847a.49.49 0 0 0-.738.423v7.949a.49.49 0 0 0 .738.422l6.786-3.973a.49.49 0 0 0 0-.846Zm-6.544 3.542v-6.24l5.327 3.12-5.327 3.12Z" />
  </svg>
);
export default SvgComponent;
